


export class ProfileFeedbackView {
    constructor() {

        this.template = document.querySelector('#feedback-template');
        this.container = document.querySelector('section.sc_feedbacks div.ul');
    }

    render(state) { 

        if (!(state && Object.keys(state).length > 0)) { return;}

        this.renderLayout('section.sc_feedbacks', state.data);
        this.renderLayout('section.sc_feedbacks.mbl_dupl', state.data);  
    }
    
    renderLayout(containerName, data) {

        const section = document.querySelector(containerName);
        if (section) {

            const title = section.querySelector('div.sc_title strong');
            if (title) { title.textContent = data.title;}

            const count = section.querySelector('div.sc_title em');
            if (count && data.totalCount) { count.textContent = data.totalCount;}

            const url = section.querySelector('a.sc_header');
            if (url) {

                url.href = data.url;

                if (data.totalCount > 6) {
                    const more = url.querySelector('div.sc_more');
                    if (more) { more.style.display = '';}
                }
            }

            if (!data.models.length) {

                section.classList.add('empty');
                section.querySelector('div.scroll_slider').remove();
                //section.querySelectorAll('div.ul .li').forEach(el => el.remove());
                section.querySelector('.sc_body_empty span').textContent = data.emptyString;
                section.querySelector('.sc_body_empty').style.display = '';
                return;
            }

            const container = section.querySelector('div.ul');
            let next = container.nextElementSibling;

            const slides = container.querySelectorAll('.li.slide');
            let index = 0;

            slides.forEach(slide => {

                const dummies = slide.querySelectorAll('div.item'); 
                dummies.forEach(dummy => {

                    if (!data.models[index]) {
                        dummy.closest('.item').remove();
                        return;
                    }

                    const model = data.models[index];

                    const f = this.renderPartial(model);

                    dummy.replaceWith(f);

                    index += 1;

                });
            });
        }
    }

    renderPartial(data) {

        const p = this.template.content.cloneNode(true);
        const article = p.querySelector('article.feedback');
        if (article) {

            article.classList.remove('dummy');
            if (data.classes && data.classes.length > 0) {
                article.classList.add(...data.classes);
            }

            const client = article.querySelector('a.user');
            if (client) {

                client.href = data.author.url;

                const avatar = client.querySelector('img');
                if (avatar) {

                    avatar.href = data.author.avatar;
                }
                const username = client.querySelector('span');
                if (username) {

                    username.textContent = data.author.username;
                }
            }

            const rating = article.querySelector('div.rating');
            if (rating) {

                const firstSpan = rating.firstElementChild;
                const lastSpan = rating.lastElementChild;

                if (firstSpan && data.author.rating.buyer) {
                    firstSpan.textContent = data.author.rating.buyer?.value;
                    if (data.author.rating.buyer?.class) {
                        firstSpan.classList.add(data.author.rating.buyer.class);
                    }
                }

                if (lastSpan && data.author.rating.seller) {
                    lastSpan.textContent = data.author.rating.seller?.value;
                    if (data.author.rating.seller?.class) {
                        lastSpan.classList.add(data.author.rating.seller?.class);
                    }
                }
            }


            const a = article.querySelector('div.content a');
            if (a) {

                a.textContent = data.comment;
                a.href = data.url;
            }

        }

        return p.firstElementChild;
    }
}